/**
 * ImageGalleryModal Component (Web)
 *
 * On web, renders as a centered lightbox overlay using a React portal.
 * The portal renders directly into document.body to avoid position: fixed
 * being broken by React Native Web's transform containers.
 * Clicking the backdrop closes the gallery.
 */

import React from 'react';
import { createPortal } from 'react-dom';
import { Colors } from '../../../../themes/colors';
import { ImageGallery } from './ImageGallery';
import type { ImageGalleryModalProps } from './ImageGalleryModal';

export const ImageGalleryModal: React.FC<ImageGalleryModalProps> = ({
  visible,
  onClose,
  animationType: _animationType,
  ...galleryProps
}) => {
  if (!visible) return null;

  const content = (
    <div style={overlayStyle} onClick={onClose}>
      <div style={containerStyle} onClick={(e) => e.stopPropagation()}>
        <ImageGallery {...galleryProps} onBack={onClose} />
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

ImageGalleryModal.displayName = 'ImageGalleryModal';

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
};

const containerStyle: React.CSSProperties = {
  width: '80%',
  maxWidth: 800,
  height: '80%',
  maxHeight: 600,
  backgroundColor: Colors.role.surface,
  borderRadius: 8,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};
